import { render, staticRenderFns } from "./UsersPrivilegeBranches.vue?vue&type=template&id=724d83d4&scoped=true&"
import script from "./UsersPrivilegeBranches.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d83d4",
  null
  
)

export default component.exports